import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-foreground text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_home-fix-pros-3/artifacts/7ckw9a8p_LOGO%20BBM.png" 
                alt="BBM Appliances Logo"
                className="h-14 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-white/70 leading-relaxed">
              Pennsylvania & NJ's top-rated appliance repair service. Professional technicians 
              dedicated to providing exceptional service.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                data-testid="social-facebook"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                data-testid="social-instagram"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-4">
              <li>
                <Link 
                  to="/" 
                  data-testid="footer-home"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/#services" 
                  data-testid="footer-services"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/service-areas" 
                  data-testid="footer-areas"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Service Areas
                </Link>
              </li>
              <li>
                <Link 
                  to="/book" 
                  data-testid="footer-book"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Book Online
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Service Areas</h3>
            <ul className="space-y-4">
              <li className="text-white/70">
                <span className="font-medium text-white">Pennsylvania:</span>
                <br />Montgomery, Bucks, Philadelphia, Delaware County
              </li>
              <li className="text-white/70">
                <span className="font-medium text-white">New Jersey:</span>
                <br />Gloucester, North Burlington, Camden County
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+18556056034" 
                  data-testid="footer-phone"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <Phone className="w-5 h-5 text-primary" />
                  (855) 605-6034
                </a>
              </li>
              <li>
                <a 
                  href="mailto:Hello@bbmappliances.com" 
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <Mail className="w-5 h-5 text-primary" />
                  Hello@bbmappliances.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/70">
                <Clock className="w-5 h-5 text-primary" />
                7AM - 7PM, 7 Days a Week
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} BBM Appliances. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <Link 
                to="/terms" 
                data-testid="footer-terms"
                className="text-white/50 hover:text-white transition-colors"
              >
                Terms of Service
              </Link>
              <span className="text-white/50">•</span>
              <Link 
                to="/privacy" 
                data-testid="footer-privacy"
                className="text-white/50 hover:text-white transition-colors"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
